export type UserData = {   
    usuario: string,
    idpersona: number,
    identificacion: string,
    apellidos: string,
    nombres: string,
    ultimoCambio: string,
    roles: Array<string>,
    token: string,
    strTipoEstructura: string,
    strTipoUsuario: string,
    idestructuraorganica: number,
    estadosolicitud:string,
    tiporenuncia:string,
    esespol: string,
    idregimenlaboral:number,    
}


type TblTokenTh = {
    username:string,
    roles:string,
    tokenth:string,
}

type PersonaModel = {
    idpersona:number,
    numeroidentificacion:string,
    apellidos:string,
    nombres:string,
    email:string,
    ultimocambio:Date,
    strtipoestructura:string,
    strtipousuario:string,
    idestructuraorganica:number|undefined,
    estadosolicitud:string,
    tiporenuncia:string,
    esespol:string,
    idregimenlaboral:number|undefined
}

export type TokenModel = {
    srtEstado:string,
    token:TblTokenTh,
    persona:PersonaModel,
    rolesusuarios:string[]

}

export type OptionsSelect = {
    label:string,
    value:string
}

export type FileInfo = {
    nombreFile: string,
    file: File,
    id: string
}

export type FileState = {
    type: string, 
    file: File, 
    id: string, 
    src: string ,
    indexElement:number
}

export type FileInfoUrl = {
    nombreFile: string,
    file: File,
    id: string,
    url: string
}

export type ResponseRequest = {
    status:number,
    errorMessage?:string,
    dataResponse?:any
}

export  type ResponseRequestGeneric<T> = {
    status:number,
    errorMessage?:string,
    dataResponse?:T
}

export enum EstadoDeudas {
    TIENE_DEUDA = 1,
    NO_TIENE_DEUDA = 2,
    ANULADO = 3
}

//Para deudas y Otros Documentos
export enum EstadoRevisionTH {
    INGRESADO = 0,
    ENVIADO_UATH= 1,
    APROBADO= 2,
    NEGADO = 3,
    ENVIADO_GERENCIA_FINANCIERA = 5,
    NOTIFICADO_SERVIDOR = 6,
    NOTIFICADO_GERENCIA_FINANCIERA = 7
}